import { render } from "./ContentMenu.vue?vue&type=template&id=37afaaa9&scoped=true&ts=true"
import script from "./ContentMenu.vue?vue&type=script&lang=ts"
export * from "./ContentMenu.vue?vue&type=script&lang=ts"

import "./ContentMenu.vue?vue&type=style&index=0&id=37afaaa9&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37afaaa9"]])

export default __exports__